(function () {

    "use strict";

    SharingWidgetService.$inject = [];

    function SharingWidgetService($state) {
        var self = this;

        self.SOCIAL_MEDIA = ['facebook', 'twitter', 'pinterest', 'linkedIn', 'whatsapp'];

        var SOCIAL_MEDIA_SHARE_URLS = {
            facebook: 'https://www.facebook.com/dialog/share?',
            twitter: 'https://twitter.com/intent/tweet?text=',
            pinterest: 'http://pinterest.com/pin/create/button/?url=',
            linkedIn: 'https://www.linkedin.com/shareArticle?url=',
            whatsapp: 'https://api.whatsapp.com/send?text=',
        };

        var UTM_SOURCE_MAP = {
            facebook: 'facebook',
            twitter: 'Twitter',
            linkedIn: 'LinkedIn',
            pinterest: 'pinterest',
            whatsapp: 'whatsapp',
        };

        self.getSocialMediaUrl = function (source, url) {
            var socialMediaUrl;
            var websiteUrl = $state.href('homepage', {}, {absolute: true});
            var currentUrl = ((url && url.indexOf('http') < 0) ? websiteUrl + url : url);

            switch (source) {
                case 'facebook':
                    var facebookAppId = publicConfiguration.keys.facebook.AppId;
                    socialMediaUrl = SOCIAL_MEDIA_SHARE_URLS[source] + 'app_id=' + facebookAppId + '&display=popup&href=' + encodeURIComponent(currentUrl);
                    break;

                case 'twitter':
                case 'pinterest':
                case 'linkedIn':
                case 'whatsapp':
                    socialMediaUrl = SOCIAL_MEDIA_SHARE_URLS[source] + encodeURIComponent(currentUrl);
                    break;
            }

            if (socialMediaUrl) {
                if (socialMediaUrl.includes('utm_source')) {
                    return socialMediaUrl.replace(new RegExp('social', 'g'), UTM_SOURCE_MAP[source]);
                } else {
                    return socialMediaUrl + '&utm_source=' + encodeURIComponent(UTM_SOURCE_MAP[source]);
                }
            }
        };
    }

    angular
        .module('harriApp')
        .service('SharingWidgetService', ["$state",
            function ($state) {
                return new SharingWidgetService($state);
            }]);

})();
